import React, {Component} from 'react';
import {TreeSelect} from 'antd';
import {locdau} from '../utils'
const TreeNode = TreeSelect.TreeNode;

class FilterGroupTreeSelect extends Component {
  constructor(props) {
    super(props);
    const {groups, treeGroups, filterGroups} = this.props
    const items = filterGroups.map((id) => {
      return groups.find((item) => {
        return item.ID === id
      })
    })
    const values = items.map((item) => {
      const kodau = locdau(item.Name).toLowerCase()
      const value = `${kodau}_${item.ID}`
      return value
    })
    this.state = {
      treeGroups: treeGroups,
      groups: groups,
      expandedKeys: [],
      selectedValues: values,
      searchValue: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({groups: nextProps.groups, treeGroups: nextProps.treeGroups, filterGroups: nextProps.filterGroups})
  }

  handleChange = (value, label, extra) => {
    const ids = value.map((val) => {
      const dashIndex = val.indexOf("_")
      return val.substr(dashIndex + 1)
    })
    this.props.onSelect(ids)
    this.setState({selectedValues: value})
  }

  handleSearch = (value) => {
    const {groups} = this.props
    const parentKeys = groups.filter((item) => {
      const kodau = locdau(item.Name).toLowerCase()
      const kodauSearch = locdau(value).toLowerCase()
      return kodau.indexOf(kodauSearch) > -1
    }).map(item => item.ParentID)

    this.setState({expandedKeys: parentKeys, searchValue: value})
  }

  render() {
    const {treeGroups, expandedKeys, searchValue, selectedValues} = this.state
    const size = this.props.size

    const loop = treeGroups => treeGroups.map((item) => {
      const kodau = locdau(item.Name).toLowerCase()
      const kodauSearch = locdau(searchValue).toLowerCase()
      const index = kodau.indexOf(kodauSearch);
      const beforeStr = item.Name.substr(0, index);
      const matchStr = item.Name.substr(index, searchValue.length);
      const afterStr = item.Name.substr(index + searchValue.length);
      const title = index > -1
        ? (<span>
          {beforeStr}
          <span className="highlight">{matchStr}</span>
          {afterStr}
        </span>)
        : <span>{item.Name}</span>;

      if (item.Childs.length > 0) {
        return (<TreeNode title={title} dataRef={item} key={item.ID} value={`${kodau}_${item.ID}`}>
          {loop(item.Childs)}
        </TreeNode>);
      }
      return <TreeNode title={title} dataRef={item} key={item.ID} value={`${kodau}_${item.ID}`}/>;
    })
    return <TreeSelect style={{
        width: '100%'
      }} size={size
        ? size
        : "large"} placeholder="Chọn địa bàn" allowClear={true} value={selectedValues} multiple={true} treeDefaultExpandedKeys={expandedKeys} onChange={this.handleChange} onSearch={this.handleSearch}>{loop(treeGroups)}
    </TreeSelect>;
  }
}

export default FilterGroupTreeSelect



// WEBPACK FOOTER //
// ./src/components/FilterGroupTreeSelect.js